import { render, staticRenderFns } from "./WalletHeader.vue?vue&type=template&id=793d2d9d&scoped=true&"
import script from "./WalletHeader.vue?vue&type=script&lang=js&"
export * from "./WalletHeader.vue?vue&type=script&lang=js&"
import style0 from "./WalletHeader.vue?vue&type=style&index=0&id=793d2d9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d2d9d",
  null
  
)

export default component.exports